
import createIconComponent from '../utils/createIconComponent';
import { SVG_GOTO_BLACK_YELLOW } from '../../../dist';
import React from 'react';
const GotoBlackYellowIcon = createIconComponent({ content: SVG_GOTO_BLACK_YELLOW, height: 24, width: 49 });
GotoBlackYellowIcon.displayName = 'GotoBlackYellowIcon';
export default GotoBlackYellowIcon;
